import { render, staticRenderFns } from "./message-dialog.vue?vue&type=template&id=5eddf924"
import script from "./message-dialog.vue?vue&type=script&lang=js"
export * from "./message-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports